import { defineStore } from 'pinia';
import { AppProfile } from 'src/services/IodineGrouperService';

export interface FeatureConfig {
  showAuditDashboard: boolean;
  showConcurrentFeatures: boolean;
}

const FEATURE_CONFIGS: Record<AppProfile, FeatureConfig> = {
  Concurrent: {
    showAuditDashboard: false,
    showConcurrentFeatures: true,
  },
  ImpactTracking: {
    showAuditDashboard: true,
    showConcurrentFeatures: false,
  },
  Retrospect: {
    showAuditDashboard: false,
    showConcurrentFeatures: false,
  },
};

export const useFeatureConfigStore = defineStore('featureConfig', {
  state: () => ({
    profile: 'Concurrent' as AppProfile
  }),

  getters: {
    features(state): FeatureConfig {
      return FEATURE_CONFIGS[state.profile] ?? FEATURE_CONFIGS['Concurrent'];
    }
  },

  actions: {
    setProfile(profile: AppProfile | undefined) {
      if (!profile || !(profile in FEATURE_CONFIGS)) {
        console.warn(`Unknown profile: ${profile}`);
        return;
      }
      this.profile = profile;
    },
    isFeatureEnabled(flag: keyof FeatureConfig): boolean {
      return this.features[flag];
    }
  },
});
